import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { changePassword } from "../../../api/users";

const inputClass =
  "tw-h-12 tw-w-full tw-rounded-lg tw-border tw-border-white/20 tw-bg-[#190033] tw-px-4 tw-pr-12 tw-text-sm tw-text-white placeholder:tw-text-white/30 focus:tw-border-[#712CB0] focus:tw-outline-none tw-transition-colors";

export default function Password() {
  const { t } = useTranslation();

  const [disabled, setDisabled] = useState(true);
  const [currentPwdShow, setCurrentPwdShow] = useState(false);
  const [pwdShow, setPwdShow] = useState(false);
  const [rePwdShow, setRePwdShow] = useState(false);

  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
    setDisabled(false);
  };

  const savePassword = () => {
    if (!passwordData.currentPassword) {
      toast.error(t("Please enter your current password"));
      return;
    }

    if (!passwordData.newPassword) {
      toast.error(t("Password cannot be empty"));
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error(t("Passwords don't match!"));
      return;
    }

    setDisabled(true);
    changePassword(passwordData.currentPassword, passwordData.newPassword)
      .then((data) => {
        toast.success(data.message || t("Password updated!"));
        setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || t("Error updating password"));
        setDisabled(false);
      });
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-max-w-md">
      <div className="tw-relative">
        <input
          name="currentPassword"
          value={passwordData.currentPassword}
          placeholder={t("Current Password")}
          type={currentPwdShow ? "text" : "password"}
          onChange={handleChange}
          className={inputClass}
        />
        <button
          type="button"
          onClick={() => setCurrentPwdShow(!currentPwdShow)}
          className="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-white/40 hover:tw-text-white/70 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer"
        >
          <FontAwesomeIcon icon={currentPwdShow ? faEyeSlash : faEye} className="tw-text-sm" />
        </button>
      </div>

      <div className="tw-relative">
        <input
          name="newPassword"
          value={passwordData.newPassword}
          placeholder={t("New Password")}
          type={pwdShow ? "text" : "password"}
          onChange={handleChange}
          className={inputClass}
        />
        <button
          type="button"
          onClick={() => setPwdShow(!pwdShow)}
          className="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-white/40 hover:tw-text-white/70 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer"
        >
          <FontAwesomeIcon icon={pwdShow ? faEyeSlash : faEye} className="tw-text-sm" />
        </button>
      </div>

      <div className="tw-relative">
        <input
          name="confirmPassword"
          value={passwordData.confirmPassword}
          placeholder={t("Confirm New Password")}
          type={rePwdShow ? "text" : "password"}
          onChange={handleChange}
          className={inputClass}
        />
        <button
          type="button"
          onClick={() => setRePwdShow(!rePwdShow)}
          className="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-white/40 hover:tw-text-white/70 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer"
        >
          <FontAwesomeIcon icon={rePwdShow ? faEyeSlash : faEye} className="tw-text-sm" />
        </button>
      </div>

      <div className="tw-flex tw-justify-end tw-mt-2">
        <button
          disabled={disabled}
          onClick={savePassword}
          className="tw-rounded-xl tw-bg-[#712CB0] hover:tw-bg-[#8B3FD9] tw-px-8 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-transition-all active:tw-scale-95 disabled:tw-bg-white/10 disabled:tw-text-white/30 disabled:tw-cursor-not-allowed tw-border-0 tw-cursor-pointer"
        >
          {t("Save Password")}
        </button>
      </div>
    </div>
  );
}
